import * as React from 'react';
import { IconProps } from '../types';

const IcSimpleMenu2 = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M2.501 4.173C2.442 2.518 3.901 1.02 5.537 1h5.144c1.675.06 3.055 1.616 3.016 3.272 1.754 0 3.508-.02 5.262 0 1.577.059 2.957 1.458 2.976 3.035v12.654c-.02 1.3-.966 2.503-2.207 2.897-.493.178-1.045.138-1.557.138H5.576c-1.616 0-3.075-1.439-3.075-3.055V4.173Zm3.075 2.385c-.532.079-.887.611-.848 1.143v11.866c-.078.67.552 1.222 1.203 1.143h12.634c.63.04 1.123-.552 1.104-1.163V7.701c.039-.59-.454-1.222-1.085-1.182-4.336.04-8.672 0-13.008.04Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M7.35 8.726c.315-.098.63-.059.946-.079 2.897.02 5.795-.02 8.692.02.769 0 1.143 1.143.572 1.636-.276.355-.769.296-1.163.296-2.878-.02-5.775.02-8.653-.02-.985.04-1.261-1.459-.394-1.853ZM7.409 12.708c.276-.119.611-.08.907-.099 2.897.02 5.775-.02 8.672.02.71.02 1.104.926.71 1.498-.217.374-.69.512-1.104.473-2.996 0-5.992.04-8.988 0-.926-.158-1.064-1.557-.197-1.892ZM7.586 16.65c2.996-.08 6.012 0 9.027-.04.513-.059 1.104.217 1.203.75.157.63-.375 1.3-1.025 1.221-3.036 0-6.051.02-9.086 0-1.065.02-1.203-1.774-.119-1.931Z"
    />
  </svg>
);

export default IcSimpleMenu2;
